const galleries = new WeakMap();

function findGallery(content) {
	return content?.matches(".media-modal-gallery")
		? content
		: content?.querySelector(".media-modal-gallery");
}

function loadImage(img) {
	if (!img || img.getAttribute("data-loaded") === "true") return;
	window.lozadObserver?.triggerLoad(img);
}

// Called only when Fancybox reveals a gallery, never during page startup.
export function initMediaGallery(content) {
	const gallery = findGallery(content);
	if (!gallery || typeof Swiper === "undefined") return false;
	if (galleries.has(gallery)) return true;

	const mainEl = gallery.querySelector(".swiper-main .swiper");
	const thumbEl = gallery.querySelector(".swiper-thumb .swiper");
	if (!mainEl || !thumbEl) return false;

	const thumbs = new Swiper(thumbEl, {
		slidesPerView: "auto",
		spaceBetween: 12,
		watchSlidesProgress: true,
		navigation: {
			prevEl: gallery.querySelector(".media-gallery-thumb-prev"),
			nextEl: gallery.querySelector(".media-gallery-thumb-next"),
		},
	});

	const loadMainImages = (swiper) => {
		const index = swiper.activeIndex;
		loadImage(swiper.slides[index]?.querySelector("img"));
		// One image ahead keeps swiping smooth without downloading the whole album.
		const next = (index + 1) % swiper.slides.length;
		loadImage(swiper.slides[next]?.querySelector("img"));
	};
	const main = new Swiper(mainEl, {
		slidesPerView: 1,
		speed: 400,
		rewind: true,
		navigation: {
			prevEl: gallery.querySelector(".media-gallery-prev"),
			nextEl: gallery.querySelector(".media-gallery-next"),
		},
		pagination: {
			el: gallery.querySelector(".swiper-main .swiper-pagination"),
			type: "fraction",
		},
		thumbs: { swiper: thumbs },
		on: { init: loadMainImages, slideChange: loadMainImages },
	});

	// The existing Lozad observer loads visible thumbnails after Fancybox reveals them.
	window.lozadObserver?.observe();

	// Delegate once per gallery instead of attaching a handler to every thumbnail.
	const onThumbnailClick = (event) => {
		const button = event.target.closest(".media-gallery-thumbnail");
		if (!button) return;
		const index = Array.from(thumbs.slides).indexOf(button.closest(".swiper-slide"));
		if (index >= 0) main.slideTo(index);
	};
	thumbEl.addEventListener("click", onThumbnailClick);
	galleries.set(gallery, { main, thumbs, thumbEl, onThumbnailClick });
	return true;
}

export function destroyMediaGallery(content) {
	const gallery = findGallery(content);
	const state = gallery && galleries.get(gallery);
	if (!state) return;
	state.thumbEl.removeEventListener("click", state.onThumbnailClick);
	state.main.destroy(true, true);
	state.thumbs.destroy(true, true);
	galleries.delete(gallery);
}
